import React, { useEffect, useState } from "react";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import {
  AddReservesConvertToSales,
  createInternalSales,
  getParentWarhouseData,
  getReservesPartPendingList,
  getwarHouseEntityList,
} from "../../services/PartsInventory";
import {
  getSerachClientProfile,
  getSerachUserProfile,
} from "../../services/ClientProfileServices";
import Select from "react-select";
import { getSettingsCompanyDetails } from "../../services/settingsServices";
import { getDocumentSetList } from "../../services/MoloniServices";

const covertSalesList = [
  { value: 1, label: "Internal" },
  { value: 2, label: "Marketplace" },
];

const InternalPendingList = ({
  setStep,
  partIdData,
  reserveDetails,
}) => {
  const location = useLocation();
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
  });
  const [totalRecords, setTotalRecords] = useState(0);

  const [reservesPenList, setReservesPenList] = useState([]);

  const [modifyqtyModal, setmodifyqtyModal] = useState(false);
  const [partqtyDetails, setPartqtyDetails] = useState("");
  const [selectedParts, setSelectedParts] = useState([]);
  const [unselectedParts, setUnselectedParts] = useState([]);
  const [resOrderData, setResOrderData] = useState({
    reservation_order_notes: "",
  });
  const [selectedPrices, setSelectedPrices] = useState({});
  const [selectedEntities, setSelectedEntities] = useState({});
  const [entityList, setEntityList] = useState([]);
  const [entityAllList, setEntityAllList] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [previousSearch, setPreviousSearch] = useState("");
  const [modifyconverToSales, setModifyconverToSales] = useState(false);
  const [converToSalesDataList, setConverToSalesDataList] = useState("");
  const [converToSalesData, setConverToSalesData] = useState({
    reservation_id: "",
    warehouses_id: "",
    seller_id: companyId?.id ? companyId?.id : "",
    sales_type: 1,
    sales_notes: "",
    client_id: "",
    shipping_price: "",
    packing_price: "",
    parcel_price: "",
    expiration_date: "",
    document_set_id: "",
  });
  const [userDataMainList, setUserDataMainList] = useState([]);
  const [userDataList, setUserDataList] = useState([]);
  const [modifyClientModal, setModifyClientModal] = useState(false);

  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [clientProfileData, setclientProfileData] = useState({
    uuid: "",
    id: "",
    name: "",
    country_id: "",
    district: "",
    city: "",
    bill_address: "",
    postal_code: "",
    shipping_addresses: [""],
    vat_country_code: "",
    vat_number: "",
    vat_percentage: 23,
    is_vat_exempt: "0",
    indicative_phone_code: "",
    phone_number: "",
    whatsapp_number: "",
    email: "",
    country_code: "",
  });
  const [settingCompanyDetails, setSettingCompanyDetails] = useState("");
  let errorsObj = {
    shipping_company: "",
    shipping_tracking_code: "",
    reason_failed_sale: "",
    add_file: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);

  const handleConvertToSaleOpen = (e) => {
    if (!selectedParts.length > 0) {
      toast.error("at least one quntity assign");
      return;
    }
    setModifyconverToSales(true);
  };

  const handleConvertToSaleClose = () => {
    setModifyconverToSales(false);
    setConverToSalesData({
      reservation_id: "",
      warehouses_id: "",
      seller_id: "",
      sales_type: 1,
      sales_notes: "",
      client_id: "",
      shipping_price: "",
      packing_price: "",
      parcel_price: "",
    });
  };

  const handleAddModal = (item) => {
    setclientProfileData({
      uuid: item?.uuid,
      id: item?.id,
      name: item?.name,
      district: item?.state_name,
      city: item?.city_name,
      bill_address: item?.bill_address,
      postal_code: item?.postal_code,
      shipping_addresses: item?.shipping_addresses,
      vat_country_code: item?.vat_country_code,
      vat_number: item?.vat_number,
      vat_percentage: item?.vat_percentage,
      is_vat_exempt: item?.is_vat_exempt,
      indicative_phone_code: item?.indicative_phone_code,
      phone_number: item?.phone_number,
      whatsapp_number: item?.whatsapp_number,
      email: item?.email,
      country_code: item?.country_code,
    });

    setModifyClientModal(true);
  };

  const handleSelectChange = (event, item) => {
    const value = event.target.value;

    setSelectedEntities((prevState) => ({
      ...prevState,
      [item.id]: value,
    }));
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyResponse = await getSettingsCompanyDetails();
        setSettingCompanyDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    let data = { ...params };
    getwarHouseEntityList(data)
      .then((response) => {
        setEntityList(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [params]);

  useEffect(function () {
    const obj = {
      search: "",
    };
    getSerachUserProfile(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setUserDataMainList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    let data = { ...params };

    getParentWarhouseData(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.id,
            label: response.data[i]?.warehouse_name,
          });
        }
        setEntityAllList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    const obj = {
      search: "",
      limit: tableLengthList[0],
      page: 1,
    };
    getSerachClientProfile(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
            fullData: response.data[i],
          });
        }

        setUserDataList(list);
      })
      .catch(() => {});
  }, []);

  const handleManualInput = (partId, value) => {
    setSelectedPrices((prev) => ({
      ...prev,
      [partId]: value,
    }));
  };

  const handleCheckboxChange = (partId, id) => {
    setSelectedParts((prevSelected) => {
      const isAlreadySelected = prevSelected.some((item) => item.id === id);

      if (isAlreadySelected) {
        const updatedSelected = prevSelected.filter((item) => item.id !== id);

        const uncheckedParts = partqtyDetails?.reserve_order_list.filter(
          (reservePart) =>
            Number(reservePart.reservation_id) === Number(reserveDetails.id) &&
            Number(reservePart.part_qty_label_id) === Number(id),
        );

        setUnselectedParts((prevUnselected) => [
          ...prevUnselected,
          ...uncheckedParts,
        ]);

        return updatedSelected;
      } else {
        setUnselectedParts((prevUnselected) =>
          prevUnselected.filter(
            (item) => Number(item.part_qty_label_id) !== Number(id),
          ),
        );

        return [...prevSelected, { parts_id: partId, id }];
      }
    });
  };

  const handleQtyOpen = (e, item) => {
    setPartqtyDetails(item);
    setmodifyqtyModal(true);
  };

  const handleQtyClose = () => {
    setmodifyqtyModal(false);
  };

  useEffect(() => {
    if (Array.isArray(reservesPenList) && reserveDetails?.id) {
      const matchingParts = reservesPenList.filter((item) =>
        item.reserve_order_list?.some(
          (r) => Number(r.reservation_id) === Number(reserveDetails.id),
        ),
      );

      if (matchingParts.length > 0) {
        setPartqtyDetails(matchingParts);

        const preSelectedParts = [];
        const preSelectedPrices = {};
        const preSelectedEntities = {};
        const preReservationNotes = {};

        matchingParts.forEach((part) => {
          part.reserve_order_list?.forEach((reserve) => {
            if (Number(reserve.reservation_id) !== Number(reserveDetails.id))
              return;

            const matchedPart = part.part_qty_list?.find(
              (p) => Number(p.id) === Number(reserve.part_qty_label_id),
            );

            if (matchedPart) {
              preSelectedParts.push(matchedPart);
              preSelectedPrices[matchedPart.id] = reserve.reserve_price;
              preSelectedEntities[matchedPart.id] = reserve.location_id;
              preReservationNotes[matchedPart.id] =
                reserve.reservation_order_notes || "";
            }
          });
        });

        setSelectedParts(preSelectedParts);
        setSelectedPrices(preSelectedPrices);
        setSelectedEntities(preSelectedEntities);
        setResOrderData((prev) => ({
          ...prev,
          reservation_order_notes: preReservationNotes,
        }));
      }
    }
  }, [reservesPenList, reserveDetails]);

  const handleQtyCloseFinal = () => {
    if (Object.keys(selectedPrices).length === 0) {
      toast.error(t("at_least_one_price_required"));
      return;
    }

    // if (Object.keys(selectedEntities).length === 0) {
    //   toast.error("At least one entity must be selected");
    //   return;
    // }

    if (!selectedParts || selectedParts.length === 0) {
      toast.error(t("at_least_one_quantity_required"));
      return;
    }

    setmodifyqtyModal(false);
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    if (savedPage) {
      setParams((prevParams) => ({
        ...prevParams,
        page: parseInt(savedPage, 10),
      }));
    }
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
      localStorage.setItem("lastVisitedPage", e.selected + 1); // Save the selected page to localStorage
    }
    setParams(paramsObj);
  };

  // useEffect(() => {
  //   if (
  //     partqtyDetails?.reserve_order_list?.length &&
  //     partqtyDetails?.part_qty_list?.length
  //   ) {
  //     const preSelectedParts = [];
  //     const preSelectedPrices = {};
  //     const preSelectedEntities = {};
  //     const preReservationNotes = {};

  //     partqtyDetails.reserve_order_list?.forEach((reservePart) => {
  //       if (Number(reservePart.reservation_id) !== Number(reserveDetails.id))
  //         return;

  //       const matchedPart = partqtyDetails?.part_qty_list.find(
  //         (part) => Number(part.id) === Number(reservePart.part_qty_label_id)
  //       );

  //       if (matchedPart) {
  //         preSelectedParts.push(matchedPart);

  //         preSelectedPrices[matchedPart.id] = reservePart.reserve_price;

  //         preSelectedEntities[matchedPart.id] = reservePart.location_id;

  //         preReservationNotes[matchedPart.id] =
  //           reservePart.reservation_order_notes || "";
  //       }
  //     });

  //     // setSelectedParts(preSelectedParts);
  //     // setSelectedPrices(preSelectedPrices);
  //     // setSelectedEntities(preSelectedEntities);
  //     // setResOrderData((prev) => ({
  //     //   ...prev,
  //     //   reservation_order_notes: preReservationNotes,
  //     // }));
  //   }
  // }, [reserveDetails, partqtyDetails]);

  const fetchPartLocation = () => {
    const partsId = partIdData?.map((x) => x?.id);

    let data = {
      parts_id: partsId,
      reservation_id: reserveDetails?.id ? reserveDetails?.id : "",
      limit: tableLengthList[0],
      page: 1,
      search: searchText,
      is_reload: false,
      company_id: companyId.company_id || 0,
      is_update: true,
    };
    getReservesPartPendingList(data)
      .then((response) => {
        setReservesPenList(response.data.data);

        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(function () {
    const partsId = partIdData?.map((x) => x?.id);

    let data = {
      parts_id: partsId,
      limit: tableLengthList[0],
      page: 1,
      search: "",
      is_reload: false,
      company_id: companyId.company_id || 0,
    };

    fetchPartLocation(data);
  }, []);

  useEffect(() => {
    if (userDataList && converToSalesData?.client_id) {
      const foundClient = userDataList.find(
        (item) => item.value == converToSalesData.client_id,
      )?.fullData;
      setclientProfileData({
        uuid: foundClient?.uuid,
        id: foundClient?.id,
        name: foundClient?.name,
        district: foundClient?.state_name,
        city: foundClient?.city_name,
        bill_address: foundClient?.bill_address,
        postal_code: foundClient?.postal_code,
        shipping_addresses: foundClient?.shipping_addresses,
        vat_country_code: foundClient?.vat_country_code,
        vat_number: foundClient?.vat_number,
        vat_percentage: foundClient?.vat_percentage,
        is_vat_exempt: foundClient?.is_vat_exempt,
        indicative_phone_code: foundClient?.indicative_phone_code,
        phone_number: foundClient?.phone_number,
        whatsapp_number: foundClient?.whatsapp_number,
        email: foundClient?.email,
        country_code: foundClient?.country_code,
      });
    }
  }, [userDataList, converToSalesData?.client_id]);

  useEffect(() => {
    if (converToSalesDataList) {
      setclientProfileData({
        uuid: "",
        id: "",
        name: converToSalesDataList?.client_name || "",

        district: converToSalesDataList?.client_district || "",
        city: converToSalesDataList?.client_city || "",
        bill_address: converToSalesDataList?.client_bill_address || "",
        postal_code: converToSalesDataList?.client_postal_code || "",
        shipping_addresses: Array.isArray(
          converToSalesDataList?.client_shipping_addresses,
        )
          ? converToSalesDataList.client_shipping_addresses
          : [],
        vat_country_code: converToSalesDataList?.client_vat_country_code || "",
        vat_number: converToSalesDataList?.client_vat_number || "",
        vat_percentage: converToSalesDataList?.client_vat_percentage || "",
        is_vat_exempt: converToSalesDataList?.client_is_vat_exempt || "0",
        indicative_phone_code:
          converToSalesDataList?.client_indicative_phone_code || "",
        phone_number: converToSalesDataList?.client_phone_number || "",
        whatsapp_number: converToSalesDataList?.client_phone_number || "",
        email: converToSalesDataList?.client_email || "",
        country_code: converToSalesDataList?.client_country_code || "",
      });
    }
  }, [converToSalesDataList]);

  const renderOptions = (nodes, level = 0) => {
    return nodes?.map((node) => {
      if (node.children && node.children.length > 0) {
        return (
          <>
            <optgroup
              label={"\u00A0\u00A0".repeat(level) + node.warehouse_name}
              key={node.id}
            />
            {renderOptions(node.children, level + 1)}
          </>
        );
      } else {
        return (
          <option value={node.id} key={node.id}>
            {"\u00A0\u00A0".repeat(level) + node.warehouse_name}
          </option>
        );
      }
    });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   if (!selectedParts.length > 0) {
  //     toast.error("at least one quntity assign");
  //     return;
  //   }

  //   const allPricesSelected = selectedParts.every(
  //     (item) =>
  //       selectedPrices[item.id] !== undefined &&
  //       selectedPrices[item.id] !== null,
  //   );

  //   if (!allPricesSelected) {
  //     toast.error(t("valid_price_required_all_parts"));
  //     return;
  //   }

  //   const partListData = [];

  //   selectedParts?.forEach((item) => {
  //     const partsId = item.parts_id;

  //     let partGroup = partListData.find((entry) => entry.parts_id === partsId);
  //     if (!partGroup) {
  //       partGroup = { parts_id: partsId, part_qty_list: [] };
  //       partListData.push(partGroup);
  //     }

  //     partGroup.part_qty_list.push({
  //       reserve_price: selectedPrices[item.id] ?? 0,
  //       reserve_vat_price: 0,
  //       part_qty_id: item.id,
  //       location_id: selectedEntities[item?.id],
  //       reservation_order_notes:
  //         resOrderData.reservation_order_notes[item.id] || "",
  //     });
  //   });

  //   const partListUncheckData = unselectedParts
  //     ?.flat()
  //     .map((x) => x?.part_qty_label_id);

  //   setStep(3);
  // };

  const handleAddressChange = (index, value) => {
    const updatedAddresses = [...clientProfileData.shipping_addresses];
    updatedAddresses[index] = value;
    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: updatedAddresses,
    });
  };

  const handleAddAddress = () => {
    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: [...clientProfileData.shipping_addresses, ""],
    });
  };

  const handleRemoveAddress = (index) => {
    const updatedAddresses = [...clientProfileData.shipping_addresses];
    updatedAddresses.splice(index, 1);
    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: updatedAddresses,
    });
  };

  const handleCloseModal = () => {
    setModifyClientModal(false);

    setclientProfileData({
      uuid: "",
      id: "",
      name: "",
      country_id: "",
      district: "",
      city: "",
      bill_address: "",
      postal_code: "",
      shipping_addresses: [""],
      vat_country_code: "",
      vat_number: "",
      vat_percentage: 23,
      is_vat_exempt: "0",
      indicative_phone_code: "",
      phone_number: "",
      whatsapp_number: "",
      email: "",
      country_code: "",
    });
  };

  const handleSaveDataModal = () => {
    setModifyClientModal(false);
  };

  const hanldeConvertToSales = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);

    let error = false;
    let errorObj = { ...errorsObj };
    if (!converToSalesData.seller_id) {
      errorObj.seller_id = `Seller is required.`;
      error = true;
      setIsDelButtonLoad(false);
    }

    if (!converToSalesData.sales_notes) {
      errorObj.sales_notes = `Seller notes required.`;
      error = true;
      setIsDelButtonLoad(false);
    }
    if (!converToSalesData.sales_type) {
      errorObj.sales_type = `Seller type required.`;
      error = true;
      setIsDelButtonLoad(false);
    }

    // if (Number(settingCompanyDetails?.is_all_sync) === 1) {
    //   if (!converToSalesData.document_set_id) {
    //     errorObj.document_set_id = `Document Set is required.`;
    //     error = true;
    //   }

    //   if (!converToSalesData.expiration_date) {
    //     errorObj.expiration_date = `Expiration Date is required.`;
    //     error = true;
    //   }
    // }
    setErrors(errorObj);
    Utils.focusError();
    if (error) return;

    const allPricesSelected = selectedParts.every(
      (item) =>
        selectedPrices[item.id] !== undefined &&
        selectedPrices[item.id] !== null,
    );

    if (!allPricesSelected) {
      toast.error(t("valid_price_required_all_parts"));
      return;
    }

    const partListData = [];

    selectedParts?.forEach((item) => {
      const partsId = item.parts_id;

      let partGroup = partListData.find((entry) => entry.parts_id === partsId);
      if (!partGroup) {
        partGroup = { parts_id: partsId, part_qty_list: [] };
        partListData.push(partGroup);
      }

      partGroup.part_qty_list.push({
        reserve_price: selectedPrices[item.id] ?? 0,
        reserve_vat_price: "0",
        part_qty_id: item.id,
        location_id: selectedEntities[item?.id],
        reservation_order_notes:
          resOrderData.reservation_order_notes[item.id] || "",
      });
    });

    const partListUncheckData = unselectedParts
      ?.flat()
      .map((x) => x?.part_qty_label_id);

    let data = {
      part_list: partListData,
      client_id: String(converToSalesData?.client_id),
      warehouses_id: String(converToSalesData?.warehouses_id),
      shipping_price: converToSalesData?.shipping_price,
      packing_price: converToSalesData?.packing_price,
      parcel_price: converToSalesData?.parcel_price,
      seller_id: converToSalesData?.seller_id,
      sales_type: converToSalesData?.sales_type,
      name: clientProfileData?.name,
      country_code: clientProfileData?.country_code,
      district: clientProfileData?.district,
      city: clientProfileData?.city,
      bill_address: clientProfileData?.bill_address,
      postal_code: clientProfileData?.postal_code,
      shipping_addresses: clientProfileData?.shipping_addresses,
      vat_country_code: clientProfileData?.vat_country_code,
      vat_number: clientProfileData?.vat_number,
      vat_percentage: clientProfileData?.vat_percentage,
      is_vat_exempt: clientProfileData?.is_vat_exempt,
      indicative_phone_code: clientProfileData?.indicative_phone_code,
      phone_number: clientProfileData?.phone_number,
      whatsapp_number: clientProfileData?.whatsapp_number,
      email: clientProfileData?.email,
      expiration_date: converToSalesData?.expiration_date,
      document_set_id: converToSalesData?.document_set_id
        ? converToSalesData?.document_set_id
        : null,
      sales_notes: converToSalesData?.sales_notes,
    };
    createInternalSales(data)
      .then((response) => {
        navigate("/internal-sales");
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6"></div>
              <div className="col-sm-6"></div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid container-custom-height-new ">
            <div className="row">
              <div className="col-md-12">
                <div className="card-header">
                  <div className="card-title m-0 float-left d-flex">
                    <button
                      type="button"
                      className="btn btn-block btn-primary"
                      onClick={() => setStep(1)}
                      style={{ width: "100px", marginTop: "10px" }}
                    >
                      {t("back")} <i className="bi bi-arrow-left-short"></i>
                    </button>
                  </div>
                  <div className="card-title m-0 float-right d-flex">
                    <button
                      type="Button"
                      className="btn btn-block btn-primary"
                      onClick={handleConvertToSaleOpen}
                      style={{ width: "100px", marginTop: "10px" }}
                    >{t("save")}<i className="bi bi-receipt"></i>
                    </button>
                  </div>
                </div>
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("search")}
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                        }}
                        onBlur={() => {
                          if (searchText !== previousSearch) {
                            setPreviousSearch(searchText); // Update the last searched term
                            fetchPartLocation(); // Call API
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="card-body fuelCardB">
                    <div className="vehicleThBg table-responsive table-responsive-vehicle">
                      <table className="table table-bordered rounded-table table-striped table-hover">
                        <thead>
                          <tr>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              Part
                            </th>

                            <th style={{ width: "1%" }}>Quantity</th>
                            <th style={{ width: "1%" }}>Reserved Quantity</th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ textAlign: "center", width: "0%" }}
                            >
                              Asssign Quantity
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {reservesPenList?.map((item, index) => (
                            <tr key={item.id}>
                              {" "}
                              <td>
                                {item.part_name} /{" "}
                                {(item?.vehicle_make_name || "") +
                                  " " +
                                  (item?.vehicle_model_name || "")}{" "}
                                / {item?.part_code} / {item?.parts_internal_id}
                              </td>
                              <td>{item?.quantity}</td>
                              <td>{item?.reserved_quantity}</td>
                              <td
                                style={{ cursor: "pointer" }}
                                onClick={(e) => handleQtyOpen(e, item)}
                              >
                                <i className="bi bi-clipboard-check"></i>
                              </td>
                            </tr>
                          ))}
                          {reservesPenList && reservesPenList.length === 0 && (
                            <tr>
                              <td colSpan={4} className="text-center">
                                Record Not Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer card-footer-part clearfix">
            <div className="pagination pagination-sm m-0 float-right">
              <ReactPaginate
                previousLabel={<i className="bi bi-chevron-double-left"></i>}
                nextLabel={<i className="bi bi-chevron-double-right"></i>}
                breakLabel={"..."}
                pageCount={Math.ceil(totalRecords / params.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(e) => handleParams(e, "pagination")}
                forcePage={params.page - 1}
                containerClassName={"pagination"}
                activeClassName={"active"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
              />
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={modifyqtyModal} size="xl">
        <ModalHeader>{`Quantity`}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div
                className="row"
                style={{
                  overflowX: "auto",
                  maxHeight: "300px",
                }}
              >
                <div className="card-body">
                  <div className="vehicleThBg table-responsive table-responsive-vehicle">
                    <table className="table table-bordered rounded-table table table-striped table-hover">
                      <thead>
                        <tr>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          ></th>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Quantity
                          </th>

                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Entity
                          </th>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Price
                          </th>

                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Notes
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {partqtyDetails?.part_qty_list?.length > 0 ? (
                          partqtyDetails.part_qty_list?.map((part, index) => (
                            <tr style={{ cursor: "pointer" }} key={index}>
                              <td>
                                <input
                                  type="checkbox"
                                  className="my-checkbox-1 form-check-input"
                                  checked={selectedParts.some(
                                    (item) => item.id === part.id,
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(
                                      part.parts_id,
                                      part.id,
                                      part,
                                    )
                                  }
                                  style={{ marginLeft: "100px" }}
                                />
                              </td>
                              <td>{part.qty}</td>

                              <td>
                                <select
                                  className="form-select"
                                  value={
                                    selectedEntities[part.id] ||
                                    part.location_ids ||
                                    ""
                                  }
                                  onChange={(e) => handleSelectChange(e, part)}
                                >
                                  <option value="" disabled>
                                    Select
                                  </option>
                                  {renderOptions(entityList)}
                                </select>
                              </td>
                              <td>
                                <div>
                                  <label>
                                    Price 1: {partqtyDetails.vat_part_price}
                                  </label>
                                </div>

                                <div>
                                  <label>
                                    Price 2:{" "}
                                    {partqtyDetails.vat_part_original_price}
                                  </label>
                                </div>

                                <div>
                                  <label>
                                    Price 2:{" "}
                                    {partqtyDetails.vat_part_cost_price}
                                  </label>
                                </div>

                                <div>
                                  <label>
                                    Manual:
                                    <input
                                      type="number"
                                      value={selectedPrices[part.id] || ""}
                                      onChange={(e) =>
                                        handleManualInput(
                                          part.id,
                                          e.target.value,
                                        )
                                      }
                                      placeholder={t("enter_manual_price")}
                                      style={{
                                        marginLeft: "10px",
                                        width: "100px",
                                      }}
                                    />
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="input-div">
                                  <textarea
                                    className="form-control"
                                    value={
                                      resOrderData.reservation_order_notes[
                                        part.id
                                      ] || ""
                                    }
                                    onChange={(e) =>
                                      setResOrderData((prev) => ({
                                        ...prev,
                                        reservation_order_notes: {
                                          ...prev.reservation_order_notes,
                                          [part.id]: e.target.value,
                                        },
                                      }))
                                    }
                                    name={`reservation_order_notes_${part.id}`}
                                    placeholder={t("notes")}
                                    rows={3}
                                  />
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" style={{ textAlign: "center" }}>
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleQtyClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="Button"
            className="btn btn-block btn-primary"
            onClick={handleQtyCloseFinal}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("save")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyconverToSales} size="xl">
        <ModalHeader>{t("converted_to_sales")}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <div className="Label-my">
                Sales Type{" "}
                <Select
                  className="my-select-v"
                  options={covertSalesList}
                  value={covertSalesList.find(
                    (item) => item.value == converToSalesData.sales_type,
                  )}
                  onChange={(selectedOption) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      sales_type: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Sales Type"}
                />
                {errors.sales_type && (
                  <span className="input-error">{errors.sales_type}</span>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                Seller{" "}
                <Select
                  className="my-select-v"
                  options={userDataMainList}
                  value={userDataMainList.find(
                    (item) => item.value == converToSalesData.seller_id,
                  )}
                  onChange={(selectedOption) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      seller_id: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Seller"}
                />
                {errors.seller_id && (
                  <span className="input-error">{errors.seller_id}</span>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  Select Client
                  <span
                    style={{
                      marginLeft: "155px",
                      fontSize: "20px",
                      color: "#81bb42",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const selectedClient = userDataList.find(
                        (item) => item.value == converToSalesData.client_id,
                      )?.fullData;

                      if (selectedClient) {
                        handleAddModal(selectedClient);
                      } else {
                        const fallbackData = {
                          uuid: "",
                          id: "",
                          name: converToSalesDataList?.client_name || "",

                          district:
                            converToSalesDataList?.client_district || "",
                          city: converToSalesDataList?.client_city || "",
                          bill_address:
                            converToSalesDataList?.client_bill_address || "",
                          postal_code:
                            converToSalesDataList?.client_postal_code || "",
                          shipping_addresses: Array.isArray(
                            converToSalesDataList?.client_shipping_addresses,
                          )
                            ? converToSalesDataList.client_shipping_addresses
                            : [],
                          vat_country_code:
                            converToSalesDataList?.client_vat_country_code ||
                            "",
                          vat_number:
                            converToSalesDataList?.client_vat_number || "",
                          vat_percentage:
                            converToSalesDataList?.client_vat_percentage || "",
                          is_vat_exempt:
                            converToSalesDataList?.client_is_vat_exempt || "0",
                          indicative_phone_code:
                            converToSalesDataList?.client_indicative_phone_code ||
                            "",
                          phone_number:
                            converToSalesDataList?.client_phone_number || "",
                          whatsapp_number:
                            converToSalesDataList?.client_phone_number || "",
                          email: converToSalesDataList?.client_email || "",
                          country_code:
                            converToSalesDataList?.client_country_code || "",
                        };

                        setclientProfileData(fallbackData);
                        handleAddModal(fallbackData);
                      }
                    }}
                  >
                    <i className="bi bi-info-circle-fill"></i>
                  </span>
                </Label>
                <Select
                  className="my-select-v"
                  options={userDataList}
                  value={userDataList.find(
                    (item) => item.value == converToSalesData.client_id,
                  )}
                  onChange={(selectedOption) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      client_id: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Client"}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                WareHouse{" "}
                <Select
                  className="my-select-v"
                  options={entityAllList}
                  value={entityAllList.find(
                    (item) => item.value == converToSalesData.warehouses_id,
                  )}
                  onChange={(selectedOption) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      warehouses_id: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select WareHouse"}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                Sales Notes{" "}
                <textarea
                  type="text"
                  className="form-control input-search"
                  value={converToSalesData.sales_notes}
                  onChange={(e) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      sales_notes: e.target.value,
                    });
                  }}
                  name="sales_notes"
                  placeholder={t("sales_notes")}
                  rows={3}
                />
                {errors.sales_notes && (
                  <span className="input-error">{errors.sales_notes}</span>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                Parcel Price{" "}
                <input
                  type="text"
                  className="form-control input-search"
                  value={converToSalesData.parcel_price}
                  onChange={(e) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      parcel_price: e.target.value,
                    });
                  }}
                  name="parcel_price"
                  placeholder={t("parcel_price")}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                Packing Price{" "}
                <input
                  type="text"
                  className="form-control input-search"
                  value={converToSalesData.packing_price}
                  name="packing_price"
                  placeholder={t("packing_price")}
                  onChange={(e) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      packing_price: e.target.value,
                    });
                  }}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                Shipping Price{" "}
                <input
                  type="text"
                  className="form-control input-search"
                  value={converToSalesData.shipping_price}
                  name="shipping_price"
                  placeholder={t("shipping_price")}
                  onChange={(e) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      shipping_price: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className="col-md-6"></div>

            {Number(settingCompanyDetails?.is_all_sync) === 1 && (
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("expirationDate")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="date"
                            value={converToSalesData.expiration_date}
                            onChange={(e) => {
                              setConverToSalesData({
                                ...converToSalesData,
                                expiration_date: e.target.value,
                              });
                            }}
                            name="expiration_date"
                            placeholder={t("expiration_date")}
                          />
                        </div>
                        {/* {errors.expiration_date && (
                                <span className="input-error">
                                  {errors.expiration_date}
                                </span>
                              )} */}
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("documentSet")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            className="my-select-v"
                            options={documentSetList}
                            value={documentSetList.find(
                              (item) =>
                                item.value ===
                                converToSalesData.document_set_id,
                            )}
                            onChange={(selectedOption) => {
                              setConverToSalesData({
                                ...converToSalesData,
                                document_set_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });
                            }}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={"Select Document Set"}
                          />
                          {/* {errors.document_set_id && (
                                  <span className="input-error">
                                    {errors.document_set_id}
                                  </span>
                                )} */}
                        </div>
                      </div>
                    </FormGroup>
                  </div>
                  <div className="col-md-4" />
                </div>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={handleConvertToSaleClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block btn-primary"
              style={{ width: "100px" }}
              onClick={hanldeConvertToSales}
            >{t("yes")}<i className="bi bi-x-lg"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyClientModal} size="lg">
        <ModalHeader>Client Profile</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">{"Name"}</Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.name}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          name: e.target.value,
                        });
                      }}
                      name={`name`}
                      maxLength={50}
                      placeholder={t("name")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Country Code"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.country_code}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          country_code: e.target.value,
                        });
                      }}
                      name={`country_code`}
                      maxLength={50}
                      placeholder={t("country_code")}
                    />
                    {errors.country_code && (
                      <span className="input-error">{errors.country_code}</span>
                    )}
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"State"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.district}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          district: e.target.value,
                        });
                      }}
                      name={`district`}
                      maxLength={50}
                      placeholder={t("district")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {t("city")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.city}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          city: e.target.value,
                        });
                      }}
                      name={`city`}
                      maxLength={50}
                      placeholder={t("city")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Bill Address"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.bill_address}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          bill_address: e.target.value,
                        });
                      }}
                      name={`bill_address`}
                      maxLength={50}
                      placeholder={t("bill_address")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Postal code"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.postal_code}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          postal_code: e.target.value,
                        });
                      }}
                      name={`postal_code`}
                      maxLength={50}
                      placeholder={t("postal_code")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"VAT country code"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.vat_country_code}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          vat_country_code: e.target.value,
                        });
                      }}
                      name={`vat_country_code`}
                      maxLength={50}
                      placeholder={t("vat_country_code")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"VAT number"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.vat_number}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          vat_number: e.target.value,
                        });
                      }}
                      name={`vat_number`}
                      maxLength={50}
                      placeholder={t("vat_number")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"VAT Percentages(%)"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.vat_percentage ?? 23}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          vat_percentage: e.target.value,
                        });
                      }}
                      name="vat_percentage"
                      maxLength={50}
                      placeholder={t("vat_percentages")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  Is VAT exempt{" "}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={clientProfileData?.is_vat_exempt === 1}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label">VAT exempt </label>
                    </div>
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Indicative phone code"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.indicative_phone_code || "+351"}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          indicative_phone_code: e.target.value,
                        });
                      }}
                      name={`indicative_phone_code`}
                      maxLength={50}
                      placeholder={t("indicative_phone_code")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Phone Number"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.phone_number}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          phone_number: e.target.value,
                        });
                      }}
                      name={`phone_number`}
                      maxLength={50}
                      placeholder={t("phone_number")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Whatsapp Number"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.whatsapp_number}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          whatsapp_number: e.target.value,
                        });
                      }}
                      name={`whatsapp_number`}
                      maxLength={50}
                      placeholder={t("whatsapp_number")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Email"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.email}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          email: e.target.value,
                        });
                      }}
                      name={`email`}
                      maxLength={50}
                      placeholder={t("email")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4"></div>

            <div className="col-md-12">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  Shipping Address
                </Label>
                <div className="col-xl-12">
                  {clientProfileData?.shipping_addresses?.map(
                    (address, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center mb-2"
                      >
                        <input
                          type="text"
                          className="form-control input-search mr-2"
                          placeholder={`Shipping address ${index + 1}`}
                          value={address}
                          onChange={(e) =>
                            handleAddressChange(index, e.target.value)
                          } // Update address
                        />
                        <i
                          className="bi bi-x-circle"
                          style={{
                            marginTop: "-41px",
                            marginLeft: "-16px",
                            color: "red",
                            cursor: "pointer",
                          }}
                          onClick={() => handleRemoveAddress(index)} // Remove address
                        ></i>
                      </div>
                    ),
                  )}

                  <button
                    type="button"
                    className="btn btn-primary btn-sm mt-2"
                    onClick={handleAddAddress} // Add address
                  >
                    ➕ Add Address
                  </button>
                </div>
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isModifyButtonLoad}
            onClick={handleCloseModal}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>
          {!isModifyButtonLoad && (
            <button
              type="button"
              className="btn btn-block btn-primary"
              style={{ width: "100px", marginTop: "10px" }}
              onClick={handleSaveDataModal}
            >{t("save")}<i className="bi bi-check2"></i>
            </button>
          )}
          {isModifyButtonLoad && (
            <Button
              color="success"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default InternalPendingList;
